import { 
	SUBDIRECTIONS_BEGIN,
	ADD_SUBDIRECTIONS,
	SUBDIRECTIONS_FAILURE,
} from 'app/actions/SubdirectionsActions';

const initialState = {
	byId: {},
	allIds: [],
	isLoading: false,
};

export default function SubdirectionsReducer (state = initialState, action) {
	switch (action.type) {
		case SUBDIRECTIONS_BEGIN: 
			return {
				...state,
				isLoading: true
			}
		case ADD_SUBDIRECTIONS: 
			let allIds = [...new Set(state.allIds.concat(action.payload.data.allIds))];
			let byId = {
				...state.byId,
				...action.payload.data.byId
			};
			return {
				...state,
				allIds,
				byId,
				isLoading: false,
			};
		case SUBDIRECTIONS_FAILURE: 
			return {
				...state,
				isLoading: false
			}
		default:
			return state;
	}
};

export const getSubirs = state => {
	return state.allIds.map( id => state.byId[id] );
}